export const DUMPERT_SETTINGS = '__DUMPERT_SETTINGS__';

export const settings = (typeof window === 'object' && window[DUMPERT_SETTINGS]) ? window[DUMPERT_SETTINGS] : {};

if (process.env.API_HOST) {
  settings.API_HOST = process.env.API_HOST;
} else if(process.env.API_HOSTNAME) {
  settings.API_HOST = `https://${process.env.API_HOSTNAME}`;
}

if (process.env.UPLOAD_HOST) {
  settings.UPLOAD_HOST = process.env.UPLOAD_HOST;
}

if (process.env.ADMIN_HOST) {
  settings.ADMIN_HOST = process.env.ADMIN_HOST;
}

if (process.env.COMMENTS_HOST) {
  settings.COMMENTS_HOST = process.env.COMMENTS_HOST;
} else if(process.env.COMMENTS_HOSTNAME) {
  settings.COMMENTS_HOST = `https://${process.env.COMMENTS_HOSTNAME}`;
}

if (process.env.STATIC_FILES_HOST) {
  settings.STATIC_FILES_HOST = process.env.STATIC_FILES_HOST;
} else if(process.env.STATIC_FILES_HOSTNAME) {
  settings.STATIC_FILES_HOST = `https://${process.env.STATIC_FILES_HOSTNAME}`;
}

if (process.env.ADS_SCRIPT) {
  settings.ADS_SCRIPT = process.env.ADS_SCRIPT;
}

if(process.env.ITEM_MODAL) {
  settings.ITEM_MODAL_VIEW = process.env.ITEM_MODAL;
}

if (process.env.NSFW_LOGIN) {
  settings.NSFW_LOGIN_VIEW = process.env.NSFW_LOGIN;
}

if(process.env.RECAPTCHA_PUBLIC_KEY) {
  settings.RECAPTCHA_PUBLIC_KEY = process.env.RECAPTCHA_PUBLIC_KEY;
}

if (!settings.API_HOST) {
  settings.API_HOST = 'https://api.dumpert.nl';
}

if (!settings.USER_HOST) {
  settings.USER_HOST = 'https://reaguurder.nl';
}

if (!settings.UPLOAD_HOST) {
  settings.UPLOAD_HOST = '//upload.dumpert.nl';
}

if (!settings.ADMIN_HOST) {
  settings.ADMIN_HOST = 'https://newadmin.dumpert.nl';
}

if (!settings.COMMENTS_HOST) {
  settings.COMMENTS_HOST = 'https://comments.dumpert.nl';
}

if (!settings.STATIC_FILES_HOST) {
  settings.STATIC_FILES_HOST = 'https://cdn.dumpert.nl';
}

if (!settings.ADS_SCRIPT) {
  settings.ADS_SCRIPT = 'https://previewshared.mediahuis.be/ka-ching/dumpert/ka-ching.umd.dev.js';
}

if (!settings.ADS_SCRIPT_2) {
  settings.ADS_SCRIPT_2 = 'https://previewshared.mediahuis.be/cxense/cxense.dumpert.js';
}

settings.PLAYER_SCRIPT_1 = '//imasdk.googleapis.com/js/sdkloader/ima3.js';

if (!settings.PLAYER_SCRIPT_2) {
  settings.PLAYER_SCRIPT_2 = '//player-acc.agnoplay.com/static/agnoplay/js/agnoplay.js';
}

if (!settings.GTM_TRACKING_ID) {
  settings.GTM_TRACKING_ID = 'GTM-KPDB6CC'; // dumpert-staging
}

if (!settings.DIDOMI_API_KEY) {
  settings.DIDOMI_API_KEY = '11ef8ac9-6270-4d5e-8b99-8d6a5bd60059';
}

if (!settings.PREROLL_TIME) {
  settings.PREROLL_TIME = 1;
}

if (!settings.RECAPTCHA_PUBLIC_KEY) {
  settings.RECAPTCHA_PUBLIC_KEY = '6LdiCLUZAAAAAECJnwZ7GHe9LYJKSyBNSBUV4u0m';
}

settings.MAX_AGE = 2 * 60 * 1000;
